import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Database, HardDrive, BarChart3, TrendingUp, AlertTriangle } from 'lucide-react';

const DatabaseHealthPanel = ({ data }) => {
    const { t } = useLanguage();

    if (!data) {
        return (
            <div className="database-health-panel">
                <div className="panel-header">
                    <Database size={20} />
                    <h3>{t('systemHealthDatabaseMonitor')}</h3>
                    <div className="status-badge critical">Bağlantı Yok</div>
                </div>
                <div className="no-data">Database bağlantısı kurulamadı</div>
            </div>
        );
    }

    const totalSize = data.tables?.reduce((sum, table) => sum + table.size_mb, 0) || 0;
    const totalRows = data.tables?.reduce((sum, table) => sum + table.row_count, 0) || 0;
    const largestTable = data.tables?.reduce((largest, table) =>
        table.size_mb > (largest?.size_mb || 0) ? table : largest, null
    );

    const TableSizeItem = ({ table, index }) => (
        <div className="table-size-item">
            <div className="table-info">
                <div className="table-name">{table.table_name}</div>
                <div className="table-stats">
                    <span>{table.row_count?.toLocaleString()} {t('systemHealthRecordCount')}</span>
                    <span>{table.size_mb} MB</span>
                </div>
            </div>
            <div className="size-bar">
                <div
                    className="size-fill"
                    style={{
                        width: `${(table.size_mb / totalSize) * 100}%`,
                        backgroundColor: index % 2 === 0 ? '#3B82F6' : '#8B5CF6'
                    }}
                ></div>
            </div>
        </div>
    );

    return (
        <div className="database-health-panel">
            <div className="panel-header">
                <Database size={20} />
                <h3>{t('systemHealthDatabaseMonitor')}</h3>
                <div className={`status-badge ${data.healthy ? 'healthy' : 'critical'}`}>
                    {data.healthy ? t('systemHealthConnectionActive') : t('systemHealthConnectionLost')}
                </div>
            </div>

            <div className="database-overview">
                <div className="overview-stats">
                    <div className="stat-card">
                        <HardDrive size={24} />
                        <div className="stat-content">
                            <div className="stat-value">{parseFloat(totalSize).toFixed(2)} MB</div>
                            <div className="stat-label">{t('systemHealthTotalDatabaseSize')}</div>
                        </div>
                    </div>
                    <div className="stat-card">
                        <BarChart3 size={24} />
                        <div className="stat-content">
                            <div className="stat-value">{totalRows.toLocaleString()}</div>
                            <div className="stat-label">{t('total_record_db')}</div>
                        </div>
                    </div>
                    <div className="stat-card">
                        <TrendingUp size={24} />
                        <div className="stat-content">
                            <div className="stat-value">{data.tables?.length || 0}</div>
                            <div className="stat-label">{t('total_record_table')}</div>
                        </div>
                    </div>
                </div>
            </div>

            {largestTable && (
                <div className="largest-table">
                    <AlertTriangle size={16} />
                    <span>
                        {t('systemHealthLargestTable')}: <strong>{largestTable.table_name}</strong>
                        ({largestTable.size_mb} MB)
                    </span>
                </div>
            )}

            <div className="table-size-analysis">
                <h4>{t('systemHealthTableSizeAnalytics')}</h4>
                <div className="table-size-list">
                    {data.tables?.map((table, index) => (
                        <TableSizeItem key={index} table={table} index={index} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DatabaseHealthPanel;